<template>
  <div :class="guia.bloqueada ? 'panel-info' : 'panel-default'" class="panel">
    <div class="panel-heading text-center" style="font-size: 12pt">
      {{ guia.autorizacao.numeroGuia }}
    </div>
    <div class="panel-body panel_info">
      <table class="table table-striped table-hover tabela_info">
        <tbody>
          <tr>
            <td><strong>Emissão</strong></td>
            <td>{{
              formatarData(guia.autorizacao.dataEmissao, 'DD/MM/YYYY')
            }}</td>
          </tr>
          <tr :title="guia.beneficiario.nome">
            <td><strong>Paciente</strong></td>
            <td>{{ limitar(guia.beneficiario.nome, 25) }}</td>
          </tr>
          <tr>
            <td><strong>Convênio</strong></td>
            <td>{{ guia.beneficiario.plano }}</td>
          </tr>
          <tr>
            <td><strong>Solicitante</strong></td>
            <td>{{
              guia.contratadoSolicitante.profissionalSolicitante.nome
            }}</td>
          </tr>
          <tr>
            <td><strong>Sessões</strong></td>
            <td>{{ guia.agendamentos.length }}</td>
          </tr>
          <tr>
            <td><strong>Especialidade</strong></td>
            <td>{{ guia.especialidade }}</td>
          </tr>
          <tr>
            <td><strong>Status</strong></td>
            <td v-if="guia.bloqueada">Enviada para Faturamento</td>
            <td v-else>Aberta</td>
          </tr>
        </tbody>
      </table>
      <div class="btn-group btn-group-justified" role="group">
        <RouterLink
          v-tooltip="'Editar'"
          data-test-id="link-auto-1"
          :to="'/guia/cadastro/' + guia._id"
          role="button"
          class="btn btn-sm btn-default"
        >
          <span class="fa fa-edit" /> Editar
        </RouterLink>
        <div class="btn-group" role="group">
          <a
            id="botaoExportarPdf"
            v-tooltip="'Imprimir'"
            data-test-id="a-botaoexportarpdf"
            href="#"
            name="botaoExportarPdf"
            class="btn btn-sm btn-default"
            @click.prevent="exportarGuia(guia)"
          >
            <span class="fa fa-file-o" /> Imprimir
          </a>
        </div>
        <RouterLink
          v-tooltip="'Sessões'"
          data-test-id="link-auto-3"
          :to="'/guia/' + guia._id + '/agendamentos'"
          role="button"
          class="btn btn-sm btn-default"
        >
          <span class="fa fa-calendar" /> Sessões
        </RouterLink>
        <div class="btn-group" role="group">
          <button
            data-test-id="button-auto-4"
            type="button"
            class="btn btn-default dropdown-toggle"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            Mais <span class="caret" />
          </button>
          <ul class="dropdown-menu">
            <li>
              <a
                id="botaoLimpar"
                data-test-id="a-botaolimpar"
                href="#"
                name="botaoLimpar"
                @click.prevent="deletar(guia)"
              >
                <span class="fa fa-trash" /> Remover
              </a>
            </li>
            <li v-if="verificaAcao('bloquear_guia')">
              <a
                id="botarEnviarFaturamento"
                data-test-id="a-botarenviarfaturamento"
                href="#"
                name="botarEnviarFaturamento"
                @click.prevent="enviarParaFaturamento(guia)"
              >
                <span class="fa fa-lock" /> Enviar para faturamento
              </a>
            </li>
            <li v-if="verificaAcao('desbloquear_guia')">
              <a
                id="botaoRemoverFaturamento"
                data-test-id="a-botaoremoverfaturamento"
                href="#"
                name="botaoRemoverFaturamento"
                @click.prevent="removerDoFaturamento(guia)"
              >
                <span class="fa fa-unlock" /> Remover do faturamento
              </a>
            </li>
            <li>
              <!-- <li v-if="verificaAcao('faturamento_guia')"> -->
              <a
                id="botaoBloquearPagamento"
                data-test-id="a-botaobloquearpagamento"
                href="#"
                name="botaoBloquearPagamento"
                @click.prevent="bloquearPagamento(guia)"
              >
                <span class="fa fa-exclamation-triangle" /> Bloquear Pagamento
              </a>
            </li>
            <li>
              <!-- <li v-if="verificaAcao('faturamento_guia')"> -->
              <a
                id="botaoDesbloquearPagamento"
                data-test-id="a-botaodesbloquearpagamento"
                href="#"
                name="botaoDesbloquearPagamento"
                @click.prevent="desbloquearPagamento(guia)"
              >
                <span class="fa fa-check-square" /> Desbloquear Pagamento
              </a>
            </li>
            <li>
              <a
                id="botaoGuiaConsulta"
                data-test-id="a-botaoguiaconsulta"
                href="#"
                name="botaoGuiaConsulta"
                @click.prevent="gerarGuiaConsulta(guia)"
              >
                <span class="fa fa-file-o" /> Gerar Guia Consulta
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ControleAcessoServico from '@/servicos/ControleAcessoServico'
import * as formatadores from '@/utils/formatadores'
const controleAcessoServico = new ControleAcessoServico()

export default {
  name: 'GuiaFicha',
  props: {
    guia: {
      type: Object,
      required: true,
    },
  },
  methods: {
    ...formatadores,
    verificaAcao(nome) {
      return controleAcessoServico.verificaAcao(nome)
    },
    deletar(guia) {
      this.$emit('guiaDeletada', guia._id)
    },
    enviarParaFaturamento(guia) {
      this.$emit('guiaEnviadaParaFaturamento', guia._id)
    },
    removerDoFaturamento(guia) {
      this.$emit('guiaRemovidaDoFaturamento', guia._id)
    },
    bloquearPagamento(guia) {
      this.$emit('guiaPagamentoBloqueado', guia._id)
    },
    desbloquearPagamento(guia) {
      this.$emit('guiaPagamentoDesbloqueado', guia._id)
    },
    gerarGuiaConsulta(guia) {
      this.$emit('gerarGuiaConsulta', guia._id)
    },
    exportarGuia(guia) {
      this.$emit('exportarGuia', guia._id)
    },
  },
}
</script>
